var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,95C25.187,95,5,74.813,5,50C5,25.187,25.187,5,50,5c24.813,0,45,20.187,45,45C95,74.813,74.813,95,50,95z M50,10.625 c-21.711,0-39.375,17.664-39.375,39.375c0,21.711,17.664,39.375,39.375,39.375c21.712,0,39.375-17.664,39.375-39.375 C89.375,28.289,71.712,10.625,50,10.625z",
    fill: "#0d2243"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.516,67.309l2.288,1.063c-4.021,3.073-7.879,5.476-11.577,7.208c-3.698,1.733-6.748,2.599-9.149,2.599 c-1.342,0-2.322-0.255-2.947-0.767c-0.623-0.512-0.937-1.319-0.937-2.424c0-2.73,1.145-7.004,3.432-12.819 c2.288-5.815,3.432-9.933,3.432-12.349c0-0.446-0.127-0.787-0.382-1.024c-0.254-0.236-0.612-0.355-1.074-0.355 c-0.74,0-1.641,0.223-2.704,0.67c-1.063,0.447-2.379,1.156-3.951,2.127l-2.149-1.182c4.297-2.888,8.25-5.146,11.854-6.775 c3.604-1.627,6.422-2.441,8.456-2.441c1.341,0,2.333,0.236,2.98,0.709c0.647,0.472,0.971,1.181,0.971,2.126 c0,0.919-0.739,3.874-2.218,8.862c-0.51,1.681-0.901,3.007-1.179,3.979c-0.971,3.256-1.733,5.961-2.288,8.113 c-0.554,2.153-0.831,3.454-0.831,3.9c0,0.551,0.15,0.959,0.45,1.222c0.301,0.263,0.773,0.394,1.421,0.394 c0.646,0,1.478-0.237,2.495-0.71C58.927,68.963,60.129,68.254,61.516,67.309z",
    fill: "#0d2243"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 56.198,
    cy: 29.933,
    r: 8.004,
    fill: "#0d2243"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/Information-Icon.2cc8e746ca3035d683d60107c5464c14.svg";
export { ForwardRef as ReactComponent };